export const STORAGE = {
	USER: {
		slug: null,
		firstName: '',
		lastName: '',
		fullName: '',
		email: '',
		groups: [],
		agreements: [],
		permissions: [],
		agreement: {},
		invoicesNumberInBuffer: null,
		advancedDesktop: false,
		dashboardReportsPermissions: {
			statusSection: false,
			overviewSection: false,
			rankingSection: false
		}
	},
	OPTIONS: {
		paginationLimitTable: 15,
		paginationLimitList: 10,
		paginationLimitNotes: 5,
		defaultCurrency: null
	},
	COMMONS: {
		animatorEditAgreement: [],
		availableReports: [],
		budgetCodes: [],
		businessRoles: [],
		companyTypes: [],
		countries: [],
		currencies: [],
		defaultAdminBankAccounts: [],
		exportTransferSchemas: [],
		externalIdCheckDuplicates: [],
		gtuCodes: [],
		importTransferSchemas: [],
		legalForms: [],
		operatingBanks: [],
		orderTypes: [],
		paymentMethods: [],
		products: [],
		referenceRateTable: [],
		reportFileFormats: [],
		taxProcedureCodes: [],
		timezones: [],
		transferAuthorization: [],
		transferHandlingMethod: [],
		transferMethods: [],
		vat: [],
		vatRateTypes: []
	}
};
